import { resolvePublicAssetUrl } from '../../../utils/resolvePublicAssetUrl';

const FACTION_ICON_BY_NAME = Object.freeze({
  'Remnants of Humanity': 'remnants.png',
  'Exolot Dominion': 'exolot.png',
  'League of Shadows': 'league.png',
  "Ra's Children": 'ra.png',
  Asrah: 'asrah.png',
  'The Conspiracy': 'conspiracy.png',
  'The Corrupted Core': 'core.png',
  'The Covenant': 'covenant.png',
  'The Divine Syndicate': 'syndicate.png',
  'The Forsaken Pact': 'forsaken.png',
  'The Hollow': 'hollow.png',
  'The Iron Alliance': 'alliance.png',
  'The Last Crusade': 'crusade.png',
  'The Shadow Consortium': 'consortium.png',
  'The Silent Accord': 'silent.png',
});

const FACTION_ORB_COLORS = Object.freeze({
  'Remnants of Humanity': '#556B2F',
  'Exolot Dominion': '#4B0082',
  'League of Shadows': '#1A1A1A',
  "Ra's Children": '#F4A460',
  Asrah: '#8B0000',
});

/**
 * @param {string} factionName
 * @returns {string}
 */
export function getSpottingObjectsFactionOrbBackground(factionName) {
  if (!factionName) {
    return '#ccc';
  }
  if (factionName === 'The Conspiracy') {
    return 'linear-gradient(to right, #8B0000 50%, #1A1A1A 50%)';
  }
  if (factionName === 'The Corrupted Core') {
    return 'linear-gradient(to right, #4B0082 50%, #8B0000 50%)';
  }
  if (factionName === 'The Covenant') {
    return 'linear-gradient(to right, #F4A460 50%, #1A1A1A 50%)';
  }
  if (factionName === 'The Divine Syndicate') {
    return 'linear-gradient(to right, #F4A460 50%, #4B0082 50%)';
  }
  if (factionName === 'The Forsaken Pact') {
    return 'linear-gradient(to right, #556B2F 50%, #8B0000 50%)';
  }
  if (factionName === 'The Hollow') {
    return 'linear-gradient(to right, #F4A460 50%, #8B0000 50%)';
  }
  if (factionName === 'The Iron Alliance') {
    return 'linear-gradient(to right, #556B2F 50%, #4B0082 50%)';
  }
  if (factionName === 'The Last Crusade') {
    return 'linear-gradient(to right, #F4A460 50%, #556B2F 50%)';
  }
  if (factionName === 'The Shadow Consortium') {
    return 'linear-gradient(to right, #1A1A1A 50%, #4B0082 50%)';
  }
  if (factionName === 'The Silent Accord') {
    return 'linear-gradient(to right, #556B2F 50%, #1A1A1A 50%)';
  }
  return FACTION_ORB_COLORS[factionName] || '#ccc';
}

/**
 * @param {string} factionName
 * @returns {string | null}
 */
export function getSpottingObjectsFactionIconPath(factionName) {
  if (!factionName) {
    return null;
  }
  const iconFile = FACTION_ICON_BY_NAME[factionName];
  if (!iconFile) {
    throw new Error(`getSpottingObjectsFactionIconPath: missing icon for ${JSON.stringify(factionName)}`);
  }
  return resolvePublicAssetUrl(`/factions/${iconFile}`);
}

/**
 * @param {string[]} factionOptions
 * @returns {{ value: number, label: string, factionName: string }[]}
 */
export function buildSpottingObjectsFactionDropdownOptions(factionOptions) {
  if (!Array.isArray(factionOptions) || factionOptions.length < 2) {
    throw new Error('buildSpottingObjectsFactionDropdownOptions: factionOptions required');
  }
  return factionOptions.map((factionName, index) => ({
    value: index,
    label: factionName,
    factionName,
  }));
}
